import { render, staticRenderFns } from "./ConfirmNotification.vue?vue&type=template&id=7615e3ee&scoped=true&"
import script from "./ConfirmNotification.vue?vue&type=script&lang=js&"
export * from "./ConfirmNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7615e3ee",
  null
  
)

export default component.exports